import { useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import AddCircle from "@material-ui/icons/AddCircle";
import Domain from "@material-ui/icons/Domain";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
// import AttendanceLocalListTableActions from "./components/table-action";
// import SearchField from "../../../../../../../../../../../components/search-field";
import { useAttendanceLocalStyles } from "../../../../../../../../../../../styles";
import { useAttendanceLocalDepartmentQueueServiceListStyles } from "./styles";
import CustomPagination from "../../../../../../../../../../../../../Components/pagination";
import { dateformat } from "../../../../../../../../../../../../../utils/dateFormat";
import { useBreadcrumbs } from "../../../../../../../../../../../../../contexts/breadcrumb";
import EmptyState from "../../../../../../../../../../../../../Components/EmptyState";
import { useAttendanceLocalDepartmentQueueServiceTimeExceptionList } from "../../../../../../../../../../../../../services/api-tansquery/attendance-local/department/queue/service-time/exception/list";
import TenMinutesAlert from "../../components/remove-alert";
import { differenceInMinutes } from "date-fns";
import AttendanceLocalDepartmentListTableActions from "./components/table-action";

export default function AttendanceLocalDepartmentQueueServiceTimeExceptionList() {
    const history = useHistory();
    const { pathname } = useLocation();
    const { slug, department_id, queue_id } = useParams<{ slug: string; department_id: string; queue_id: string }>();
    const { setBreadcrumbs } = useBreadcrumbs();
    const { classes } = useAttendanceLocalDepartmentQueueServiceListStyles();
    const { classes: defaultClasses } = useAttendanceLocalStyles();
    const { data: serviceTimeExceptionList, isLoading } = useAttendanceLocalDepartmentQueueServiceTimeExceptionList({
        fila: Number(queue_id),
    });

    const isEmpty = (serviceTimeExceptionList?.results ?? []).length === 0;

    const lessThanTenMinutes = (date: string) => {
        const diff = differenceInMinutes(new Date(), new Date(date));
        return diff < 10;
    };

    useEffect(() => {
        setBreadcrumbs((prev) => {
            const homeBreadcrumb = prev.find((_, index) => index === 0);
            return [
                homeBreadcrumb,
                {
                    label: "Locais de Atendimento",
                    path: "/locais-de-atendimento",
                    icon: Domain,
                },
                {
                    label: "Setor",
                    path: `/locais-de-atendimento/${slug}/setor/${department_id}`,
                    icon: Domain,
                },
                {
                    label: "Exceção de Horários (Serviços)",
                    path: "",
                }
            ];
        });
    }, [setBreadcrumbs, slug, department_id]);

    return (
        <Box>
            <Box>
                <Button
                    className={classes.backButton}
                    startIcon={<ChevronLeft />}
                    onClick={() => history.goBack()}
                >
                    Voltar
                </Button>
            </Box>
            <TenMinutesAlert
                titulo="A nova exceção de horário foi registrada com sucesso!"
                descricao="Por até 10 minutos, ainda será possível excluir a exceção cadastrada, após isso a exceção estará disponível."
            />
            <Box className={classes.header}>
                <Typography className={classes.title}>
                    Exceção de Horários (Serviços)
                </Typography>
                <Button
                    startIcon={<AddCircle />}
                    className={defaultClasses.addButton}
                    onClick={() => history.push(`${pathname}/novo`)}
                >
                    Serviço
                </Button>
            </Box>
            <Paper elevation={3} style={{ overflow: "hidden" }}>
                {/* <SearchField /> */}
                <TableContainer className={defaultClasses.tableContainer}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell className={defaultClasses.tableTH}>
                                    Serviço
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH}>
                                    Data
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH}>
                                    Tempo Presencial
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH}>
                                    Tempo Online
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH}>
                                    Adicionado
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH} />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {serviceTimeExceptionList?.results.map((serviceTime) => (
                                <TableRow key={serviceTime.id} hover>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {serviceTime.servico.servico.titulo}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {dateformat(serviceTime.data)}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {serviceTime.tempo_presencial}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {serviceTime.tempo_online}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {dateformat(serviceTime.created_at, true)}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {lessThanTenMinutes(serviceTime.created_at) && (
                                            <AttendanceLocalDepartmentListTableActions
                                                service={serviceTime}
                                            />
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    {isEmpty && (
                        <EmptyState
                            loading={isLoading}
                            loadingText="Carregando exceções de horários de serviços..."
                            message="Nenhuma exceção de horário de serviço encontrada."
                        />
                    )}
                </TableContainer>
                <Box className={defaultClasses.paginationContainer}>
                    <CustomPagination
                        count={serviceTimeExceptionList?.count}
                        page={serviceTimeExceptionList?.current}
                        totalPages={serviceTimeExceptionList?.total_pages}
                    />
                </Box>
            </Paper>
        </Box>
    );
}
